<template>
    <div
        class="flex flex-col justify-center lg:justify-end items-center lg:items-end min-h-screen uppercase font-extrabold font-condensed w-screen overflow-x-hidden"
        id="indexHero"
        ref="indexHero"
        style="background-color: white;"
    >
        <transition name="opacity_long">
            <div class="absolute inset-0 overflow-hidden"
                 style="background: white;"
                 v-if="!backgroundLoaded"
            >
                <div class="absolute inset-0"
                     id="indexHeroBackground"
                     ref="indexHeroBackground"
                ></div>
            </div>
        </transition>

        <div class="flex flex-col items-end justify-end w-full h-full px-10 lg:px-20 xl:px-32 mt-24 tablet:mt-0"
             id="indexHeroContent"
        >
            <div class="flex flex-row justify-center self-center lg:self-end mb-16">
                <div class="bg-white text-black p-5 pl-8 pr-8 text-center transparentText" id="transparentText"
                     v-html="tr('indexHero.title')">

                </div>
            </div>

            <div class="flex flex-col z-10">
                <div class="flex flex-col items-center">
                    <div class="text-white text-2xl w-1/2 tablet:w-full">
                        {{ tr('indexHero.weAreMembers') }}
                    </div>
                </div>

                <div class="flex flex-row items-center justify-center flex-wrap tablet:flex-no-wrap mb-10">
                    <div class="flex items-center justify-center tablet:justify-start">
                        <div class="tablet:mr-5 w-1/2 tablet:w-1/4 lg:w-2/12">
                            <img alt="" class="object-contain w-full h-full inline-block"
                                 src="../assets/img/index/bim.png">
                        </div>
                    </div>

                    <div
                        class="flex flex-row justify-end xl:justify-start pb-6 xl:pb-0 h-full whitespace-no-wrap mt-16 tablet:mt-0">
                        <div class="bg-white p-3 pt-1 pb-1 text-3xl transparentText text-black cursor-pointer"
                             v-on:click="navigateTo('#howDoWeDoIt')"
                        >
                            {{ tr('indexHero.learnMore') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

const Background = '/img/public/index/eperia.jpg';
const background = src => `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${src}') no-repeat top center/cover`;

export default {
    name: 'IndexHero',
    mixins: [Translatable],
    data() {
        return {
            backgroundLoaded: false,
        };
    },
    mounted() {
        let image = new Image();
        image.src = Background;

        if (image.complete)
            this.setImage(Background);
        else
            image.onload = () => setTimeout(() => this.setImage(Background), 500);
    },
    methods: {
        navigateTo(key) {
            this.$emit('navigate-to', key);
        },

        setImage(src) {
            this.$refs['indexHero'].style.background = background(src);
            this.$nextTick(() => this.backgroundLoaded = true);
        },
    },
};
</script>

<style scoped>
#indexHero {
    width: 100vw;
    height: auto;
}

#indexHeroBackground {
    background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('/img/public/index/eperia_placeholder.jpg') no-repeat top center/cover;
    margin: -10vh -10vw;

    filter: blur(8px);
}

#transparentText {
    font-weight: 800;
    font-size: 7rem;
    line-height: 7rem;
}

.transparentText {
    mix-blend-mode: screen;
}

@media (max-width: 1024px) {
    #transparentText {
        font-weight: 800;
        font-size: 5rem;
        line-height: 5rem;
    }
}

@media (max-width: 768px) {
    #transparentText {
        font-weight: 700;
        font-size: 4rem;
    }

}

@media (max-width: 640px) {
    #transparentText {
        font-weight: 600;
        font-size: 2.5rem;
    }
}

@media (max-width: 340px) {
    #transparentText {
        font-size: 2rem;
        /* line-height: 1rem; */
    }

}
</style>
